import { render } from "./FormSchedule.vue?vue&type=template&id=52245725&scoped=true"
import script from "./FormSchedule.vue?vue&type=script&lang=js"
export * from "./FormSchedule.vue?vue&type=script&lang=js"

import "./FormSchedule.vue?vue&type=style&index=0&id=52245725&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52245725"]])

export default __exports__